export default __webpack_public_path__ + "static/media/acc2.ce2753b3.jpg";